/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideSvgIcons, SvgIconComponent } from '@ngneat/svg-icon';
import { TranslocoModule } from '@jsverse/transloco';
import { fasHeartIcon } from 'IconLibrary/fontawesome/solid/heart';
import { faHeartIcon } from 'IconLibrary/fontawesome/regular/heart';
import { PageViewLikesComponent } from './page-view-likes/page-view-likes.component';
import { BulbPageViewFooterTranslationProvider } from './translation-provider';
import { BulbAnimationsModule } from '../bulb-animations/bulb-animations.module';

(fasHeartIcon as any).name = 'heart-solid';
@NgModule({
  declarations: [
    PageViewLikesComponent,
  ],
  providers: [
    BulbPageViewFooterTranslationProvider,
    provideSvgIcons([
      fasHeartIcon,
      faHeartIcon,
    ]),
  ],
  imports: [
    BulbAnimationsModule,
    BrowserAnimationsModule,
    CommonModule,
    SvgIconComponent,
    TranslocoModule,
  ],
  exports: [
    PageViewLikesComponent,
  ],
})
export class PageViewFooterModule { }
